/**
 * Phase 67-07b — fleet-wide reboot-loop badge in Topbar.
 *
 * Mirrors StaleBadge (Phase 67-01 D-04 touchpoint 1). Renders nothing
 * when zero kiosks looped in the past 24h. Renders count + warning icon
 * when at least one kiosk has ≥3 fresh-boot heartbeats in 30min.
 *
 * Backed by audit_log rows emitted by RebootLoopDetector
 * (source=`reboot_loop_detector`).
 */

import { RotateCw } from "lucide-react";

import { useRebootLoops } from "@/hooks/queries/useRebootLoops";

export default function RebootLoopBadge() {
  const { count, isLoading } = useRebootLoops();
  if (isLoading || count === 0) return null;

  return (
    <div
      data-testid="reboot-loop-badge"
      className="flex items-center gap-1 px-2 py-1 rounded-md
                 bg-orange-100 text-orange-900 dark:bg-orange-900/30
                 dark:text-orange-200 text-xs font-medium"
      title={`${count} kiosk in reboot-loop (≥3 fresh boots in 30 min)`}
    >
      <RotateCw className="w-3.5 h-3.5" />
      <span>
        {count} reboot{count !== 1 ? "s" : ""}
      </span>
    </div>
  );
}
